module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart-plus-3460b449.svg";